module.exports = __webpack_public_path__ + "static/media/rober1.a44a2f53.jpg";